import { createElement } from 'react';
import { Popover as OriginalPopover } from 'antd';
const Popover = (props) => {
    return createElement(OriginalPopover, { ...props, open: !props.open ? undefined : props.open });
};
export default Popover;
